module.exports = __webpack_public_path__ + "img/Step2@3x.e6e8e831.jpg";